import { createSelector } from '@ngrx/store';

import { getBecomeACustomerState } from '../../become-a-customer-feature.selector';

export const getFeatureFlags = (flagId?: string | undefined) =>
  createSelector(getBecomeACustomerState, (state) => {
    if (flagId) {
      return state?.featureFlags?.[flagId];
    }

    return state?.featureFlags;
  });
